import { supportRequestInputIdentifiers, SupportRequestPrefillData } from './types';

const attachPrefillData = (supportRequestUrl: URL, prefillData: SupportRequestPrefillData): URL => {
  (Object.keys(prefillData) as Array<keyof SupportRequestPrefillData>).forEach(field => {
    if (supportRequestInputIdentifiers[field] && prefillData[field]) {
      supportRequestUrl.searchParams.append(supportRequestInputIdentifiers[field], prefillData[field] as string);
    }
  });

  return supportRequestUrl;
};

export const buildSupportRequestUrl = ({
  formId,
  prefillData,
}: {
  formId?: string;
  prefillData?: SupportRequestPrefillData;
}): URL => {
  const supportUrl = process.env.CONTACT_US_URL || 'https://support.jbhifi.com.au/hc/en-au/requests/new';

  const supportRequestUrl = new URL(supportUrl);
  if (formId) {
    supportRequestUrl.searchParams.append('ticket_form_id', formId);
  }
  if (prefillData) {
    return attachPrefillData(supportRequestUrl, prefillData);
  }
  return supportRequestUrl;
};
